export default __webpack_public_path__ + "static/media/lars.cfadc0c7.webp";